import { useEffect, useState } from "react";
import { errorMessage } from "./coffeeApi";
export const DRINKS = [
  "Expreso",
  "Americano",
  "Cortado",
  "Con Leche",
  "Con Leche fuerte",
  "Moka / Mocaccino",
  "Chocolate",
  "Capuccino",
  "Leche Caliente",
  "Avena",
  "Te Chai",
  "Agua caliente",
  "Agua Caliente Con Azucar",
  "Descaf. espreso",
  "Descaf. Americano / Americano Suave",
  "Descaf. Capuchino",
  "Latte",
  "Macchiato",
  "Lungo",
  "Hot Kumquat Lemon / Café con leche",
];
const LEGACY_DRINK_INDICES = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  null,
  null,
  12,
  null,
  null,
  null,
  null,
  null,
];
export const normalizeDrinks = (values, empty = null) => {
  const source = Array.isArray(values) ? values : [];
  return DRINKS.map((_, i) => {
    const index = source.length === 13 ? LEGACY_DRINK_INDICES[i] : i;
    return index === null ? empty : source[index] ?? empty;
  });
};
export const AUDITS = Array.from(
  { length: 12 },
  (_, i) => `Auditoria ${i + 1}`
);
export const todayPanama = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Panama",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
export const emptyForm = () => ({
  from: todayPanama(),
  until: todayPanama(),
  fromTime: null,
  untilTime: null,
  initialCounter: "",
  currentCounter: "",
  drinks: Array(DRINKS.length).fill(""),
  tests: "",
  totalSales: "",
  photos: [],
  audits: Array(12).fill(""),
});
const numeric = (value) =>
  value === "" || value == null ? null : Number(value);
export const payload = (form) => ({
  ...form,
  // Keep one-photo submissions compatible during rolling deployments.
  ...(Array.isArray(form.photos) ? { photo: form.photos[0] || "" } : {}),
  initialCounter: numeric(form.initialCounter),
  currentCounter: numeric(form.currentCounter),
  drinks: form.drinks.map(numeric),
  tests: numeric(form.tests),
  totalSales: numeric(form.totalSales),
  audits: form.audits.map(numeric),
});
export const editForm = (record) => ({
  from: record.from,
  until: record.until,
  fromTime: record.fromTime ?? null,
  untilTime: record.untilTime ?? null,
  initialCounter: record.initialCounter ?? "",
  currentCounter: record.currentCounter,
  drinks: normalizeDrinks(record.drinks, ""),
  tests: record.tests ?? "",
  totalSales:
    record.totalSalesCents == null ? "" : record.totalSalesCents / 100,
  audits: AUDITS.map((_, i) =>
    record.auditsCents?.[i] == null ? "" : record.auditsCents[i] / 100
  ),
});
export const periodLabel = (record) =>
  `${record.from || record.until}${
    record.fromTime ? " " + record.fromTime : ""
  } → ${record.until}${record.untilTime ? " " + record.untilTime : ""}`;
export const usd = (cents) =>
  cents == null
    ? "Sin reportar"
    : new Intl.NumberFormat("es-PA", {
        style: "currency",
        currency: "USD",
      }).format(cents / 100);
export const queryString = (filters) =>
  new URLSearchParams(
    Object.entries(filters).filter(([, value]) => value !== "" && value != null)
  ).toString();
export function useResource(key, request, refresh = 0) {
  const [state, setState] = useState({ key: null, loading: false });
  useEffect(() => {
    let active = true;
    if (key == null) {
      setState({ key, loading: false });
      return undefined;
    }
    setState({ key, loading: true });
    request(key)
      .then((data) => {
        if (active) setState({ key, data, loading: false });
      })
      .catch((error) => {
        if (active)
          setState({ key, error: errorMessage(error), loading: false });
      });
    return () => {
      active = false;
    };
  }, [key, request, refresh]);
  return state.key === key ? state : { loading: key != null };
}
